import {MsalGuardConfiguration, MsalInterceptorConfiguration} from "@azure/msal-angular";
import {environment} from "../environments/environment";
import {
    BrowserCacheLocation,
    Configuration,
    InteractionType,
    IPublicClientApplication,
    LogLevel,
    PublicClientApplication
} from "@azure/msal-browser";

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;


export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string,
        Array<string>>();
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
    protectedResourceMap.set(environment.baseApiURL, environment.authentication.scopes);
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}

const msalConfig: Configuration = {
    auth: {
        clientId: environment.authentication.ApplicationId,
        authority: environment.authentication.Authority + environment.authentication.TenantId,
        redirectUri: environment.authentication.redirectUrl,
        postLogoutRedirectUri: environment.authentication.logoutRedirectUrl
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE
    },
    system: {
        loggerOptions: {
            loggerCallback(LogLevel, message) {
            },
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false
        },
    }
}

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: authService => {
            return {
                scopes: environment.authentication.scopes,
                authority: environment.authentication.Authority + environment.authentication.TenantId,
                redirectUri: environment.authentication.redirectUrl,
                postLogoutRedirectUri: environment.authentication.logoutRedirectUrl
            };
        }
    };
}


